/* eslint no-use-before-define: 0 */

import { mouseLeftTileContainer$, mouseEnteredTile$ } from "@sharedFrontend/globalEvents";

import Rx from "rxjs/Rx";

const markerClickedSubject = new Rx.Subject();
// it will always have active icon
let selectedMarker = null;

export const markerClicked$ = markerClickedSubject.asObservable();

export default class MarkerComponent {
    /**
     *
     * @param {Object} place - one particular search result. Initially comes from global search results.
     * @param {string} iconUrl
     * @param {string} activeIconUrl
     * @param {bool} apartmentMode
     * @param {Object} mapClicked$ - event
     */
    constructor(place, iconUrl, activeIconUrl, apartmentMode, mapClicked$) {
        this.iconUrl = iconUrl;
        this.activeIconUrl = activeIconUrl;
        this.innerMarker = null;
        this.place = place;
        this.apartmentMode = apartmentMode;

        this.initialize(mapClicked$);
    }

    /**
     * @public
     */
    bindMap(map) {
        this.innerMarker.setMap(map);
    }

    /**
     * @public
     */
    unbindMap() {
        this.innerMarker.setMap(null);
    }

    /**
     * @public
     */
    getPosition() {
        return this.innerMarker.getPosition();
    }

    /**
     * @private
     */
    initialize(mapClicked$) {
        this.initializeInnerMarker();
        this.initializeEventsHandlers(mapClicked$);
    }

    /**
     * @private
     */
    initializeInnerMarker() {
        this.innerMarker = new window.google.maps.Marker({
            position: this.place,
            icon: this.iconUrl,
        });
    }

    /**
     * @private
     */
    addHighlight() {
        this.innerMarker.setIcon(this.activeIconUrl);
    }

    /**
     * @private
     */
    removeHighlight() {
        if (this.apartmentMode && selectedMarker === this.innerMarker) {
            return;
        }

        this.innerMarker.setIcon(this.iconUrl);
    }

    /**
     * @private
     */
    initializeEventsHandlers(mapClicked$) {
        mouseEnteredTile$.subscribe((id) => {
            if (id === this.place.estateId) {
                this.addHighlight();
            } else {
                this.removeHighlight();
            }
        });

        mouseLeftTileContainer$.subscribe(() => this.removeHighlight());

        markerClicked$.subscribe((args) => {
            if (this.innerMarker !== args.target) {
                this.removeHighlight();
            }
        });

        this.innerMarker.addListener("click", () => {
            selectedMarker = this.innerMarker;
            this.addHighlight();

            markerClickedSubject.next({
                data: this.place,
                target: this.innerMarker,
            });
        });

        mapClicked$.subscribe(() => {
            selectedMarker = null;
            this.removeHighlight();
        });
    }
}
